import { render, staticRenderFns } from "./ProviderRow.vue?vue&type=template&id=5d1c83c4&scoped=true"
import script from "./ProviderRow.vue?vue&type=script&lang=js"
export * from "./ProviderRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1c83c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d1c83c4')) {
      api.createRecord('5d1c83c4', component.options)
    } else {
      api.reload('5d1c83c4', component.options)
    }
    module.hot.accept("./ProviderRow.vue?vue&type=template&id=5d1c83c4&scoped=true", function () {
      api.rerender('5d1c83c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/purchaseService/components/ProviderRow.vue"
export default component.exports